var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"is-pulled-left is-medium has-text-primary",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){$event.preventDefault();return _vm.perform($event)}}},[_c('b-icon',{attrs:{"icon":"angle-left"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a6cb57e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/actions/HistoryBack.vue
// module id = 319
// module chunks = 1